
















































































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import DocumentInfo from '@/components/Stats/DocumentStats/DocumentInfo/index.vue';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    DocumentInfo,
  },
})
export default class DocumentTable extends Vue {
  @PropSync('docItems', {}) docItemSync!: [];

  @PropSync('documentCounts', {}) documentSync!: [];

  @PropSync('marketSelected', {}) marketSelect!: any;

  @PropSync('loading', {}) loadings!: boolean;

  private seeList: boolean = false;

  private headers: any[] = [];

  public mounted() {
    if (this.userRole === 'fw_admin'
      || this.userRole === 'fw_manager') {
      this.headers = [
        {
          text: 'Restaurant Name',
          align: 'left',
          value: 'partner',
          width: '300px',
        },
        {
          text: 'Type',
          align: 'left',
          value: 'docType',
          width: '200px',
        },
        {
          text: 'Upload Date',
          align: 'left',
          value: 'dateFormatted',
          width: '190px',
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
          width: '190px',
        },
      ];
    } else {
      this.headers = [
        {
          text: 'Document Name',
          align: 'left',
          value: 'documentName',
          width: '300px',
        },
        {
          text: 'Type',
          align: 'left',
          value: 'docType',
          width: '200px',
        },
        {
          text: 'Upload Date',
          align: 'left',
          value: 'dateFormatted',
          width: '190px',
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
          width: '190px',
        },
      ];
    }
  }

  public get userRole() {
    return UserModule.currentRole;
  }

  public onClickDocs() {
    this.seeList = true;
  }
}
